import {BLOG_CONSTS} from "../constants";

export const initialState = {
    blog:[],
    blogCount:null,
    event:[],
    news:[],
    travel:[],
    project:[],
    video:[],
    search:[],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case BLOG_CONSTS.BLOG_GET:
            return {
                ...state,
                blog:action.payload
            };
        case BLOG_CONSTS.GET_BLOG_COUNT:
            return {
                ...state,
                blogCount:action.payload?.blogsCount
            };
        case BLOG_CONSTS.EVENT_GET:
            return {
                ...state,
                event:action.payload
            };
        case BLOG_CONSTS.NEWS_GET:
            return {
                ...state,
                news:action.payload
            };
        case BLOG_CONSTS.GET_TRAVEL:
            return {
                ...state,
                travel:action.payload
            };
        case BLOG_CONSTS.GET_PROJECT:
            return {
                ...state,
                project:action.payload
            };
        case BLOG_CONSTS.GET_VIDEO:
            return {
                ...state,
                video:action.payload
            };
        case BLOG_CONSTS.GET_SEARCH:
            return {
                ...state,
                search:action.payload
            };
        default:
            return state;
    }
};
